import { render, staticRenderFns } from "./FireMarshalContact.vue?vue&type=template&id=b1e0ff52&scoped=true&"
import script from "./FireMarshalContact.vue?vue&type=script&lang=js&"
export * from "./FireMarshalContact.vue?vue&type=script&lang=js&"
import style0 from "./FireMarshalContact.vue?vue&type=style&index=0&id=b1e0ff52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1e0ff52",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b1e0ff52')) {
      api.createRecord('b1e0ff52', component.options)
    } else {
      api.reload('b1e0ff52', component.options)
    }
    module.hot.accept("./FireMarshalContact.vue?vue&type=template&id=b1e0ff52&scoped=true&", function () {
      api.rerender('b1e0ff52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/ccd/tenancy/view/FireMarshalContact.vue"
export default component.exports